export const CZECH_CURRENCY = 'CZK';
